export const offeringConfig = {
   types: ["TITHE", "GENERAL OFFERING", "THANKSGIVING", "SEED", "PROJECT"],
   sourceCodes: ["WEB", "CASH", "TRANSFER"],
   allowedCurrencies: ["NGN", "USD", "GBP"],
};
export const membershipLevels = ["FULL MEMBER", "FIRST TIMER", "NEW CONVERT", "ATTENDEE"];
